import { connect } from 'react-redux'

import {
  isOnboardingActive,
  isOwnerOnboardingActive,
  isOnboardingOnInviteStep,
} from 'screens/OnboardingPopover/utils'
import {
  isSidebarCollapsed,
  getActiveNoteId,
  getActiveChannelId,
} from 'data/ui/selectors'

export default connect(state => ({
  noteId: getActiveNoteId(state),
  channelId: getActiveChannelId(state),
  isSidebarCollapsed: isSidebarCollapsed(state),
  showLoadingPlaceHolder:
    (isOnboardingActive(state) && !isOwnerOnboardingActive(state)) ||
    (isOwnerOnboardingActive(state) && isOnboardingOnInviteStep(state)),
}))
